import React from "react";
import { Dialog, DialogContent, DialogTrigger } from "../../ui/shadcn-ui/dialog";
import { useNotificationContext } from "../../../Contexts/NotificationContext";
import  NotificationList from "./NotificationsList";

const  NotificationDialog: React.FC = () => {
    const { unreadCount } = useNotificationContext(); // Add markAsReadOnServer

    return (
        <Dialog>
            <DialogTrigger asChild>
                <button className="justify-start text-left">
                    Notifications
                    {unreadCount > 0 && (
                        <span className="ml-2 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-white bg-red-600 rounded-full">
                            {unreadCount}
                        </span>
                    )}
                </button>
            </DialogTrigger>
            <DialogContent className="max-w-lg">
                <NotificationList />
            </DialogContent>
        </Dialog>
    );
}
export default NotificationDialog
